import MuiBox, { BoxProps as Props } from '@material-ui/core/Box'
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles'
import * as React from 'react'

import Color from './Color'

export type CustomBoxProps = {
  modalOverlay?: boolean
  colorSystem?:
    | 'primary'
    | 'secondary'
    | 'cta'
    | 'black'
    | 'white'
    | 'success'
    | 'error'
    | 'link'
    | 'additional1'
    | 'additional2'
    | 'base1'
    | 'base2'
    | 'base3'
    | 'tint1'
    | 'tint2'
    | 'tint3'
}

export type BoxProps = Props & CustomBoxProps

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    modalOverlay: {
      background: Color.base.modalOverlay
    },
    colorPrimary: {
      background: theme.palette.primary.main
    },
    colorSecondary: {
      background: theme.palette.secondary.main
    },
    colorCta: {
      background: Color.base.cta
    },
    colorBlack: {
      background: theme.palette.common.black
    },
    colorWhite: {
      background: theme.palette.common.white
    },
    colorSuccess: {
      background: theme.palette.success.main
    },
    colorError: {
      background: theme.palette.error.main
    },
    colorLink: {
      background: theme.palette.info.main
    },
    colorAdditionall: {
      background: Color.base.firstAdditional
    },
    colorAdditional2: {
      background: Color.base.secondAdditional
    },
    colorBase1: {
      background: Color.base.firstBase
    },
    colorBase2: {
      background: Color.base.secondBase
    },
    colorBase3: {
      background: Color.base.thirdBase
    },
    colorTint1: {
      background: Color.base.firstTint
    },
    colorTint2: {
      background: Color.base.secondTint
    },
    colorTint3: {
      background: Color.base.thirdTint
    }
  })
)

const Box: React.FC<BoxProps> = (props) => {
  const classes = useStyles()
  const { modalOverlay, colorSystem, children, ...rest } = props
  const getStyle = () => {
    if (modalOverlay) {
      return classes.modalOverlay
    } else if (colorSystem === 'primary') {
      return classes.colorPrimary
    } else if (colorSystem === 'secondary') {
      return classes.colorSecondary
    } else if (colorSystem === 'cta') {
      return classes.colorCta
    } else if (colorSystem === 'black') {
      return classes.colorBlack
    } else if (colorSystem === 'white') {
      return classes.colorWhite
    } else if (colorSystem === 'success') {
      return classes.colorSuccess
    } else if (colorSystem === 'error') {
      return classes.colorError
    } else if (colorSystem === 'link') {
      return classes.colorLink
    } else if (colorSystem === 'additional1') {
      return classes.colorAdditionall
    } else if (colorSystem === 'additional2') {
      return classes.colorAdditional2
    } else if (colorSystem === 'base1') {
      return classes.colorBase1
    } else if (colorSystem === 'base2') {
      return classes.colorBase2
    } else if (colorSystem === 'base3') {
      return classes.colorBase3
    } else if (colorSystem === 'tint1') {
      return classes.colorTint1
    } else if (colorSystem === 'tint2') {
      return classes.colorTint2
    } else if (colorSystem === 'tint3') {
      return classes.colorTint3
    }
  }
  return (
    <MuiBox className={getStyle()} {...rest}>
      {children}
    </MuiBox>
  )
}

export default Box
